module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    ref: "chart"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b0b3a30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/nvd3-bar-chart.vue
// module id = 603
// module chunks = 4 5 6